module.exports = __webpack_public_path__ + "img/kemenhub-icon.eed795de.png";